module.exports = __webpack_public_path__ + "img/comment-dots.31709259.svg";